// src/components/services/report/reportService.ts
import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Report"],
  endpoints: (builder) => ({
    // Get list of reports (paginated)
    getReportList: builder.query({
      query: (params) => ({
        url: "/report/list",
        method: "GET",
        params,
      }),
      providesTags: ["Report"],
    }),

    // Get report detail by ID
    getReportDetail: builder.query({
      query: (id) => ({
        url: `/report/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, id) => [{ type: "Report", id }],
    }),

    getSubmittedReports: builder.query({
      query: ({ show_all }) => ({
        url: "/report/submitted_reports",
        method: "GET",
        params: { show_all },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Report", id })),
              { type: "Report", id: "LIST" },
            ]
          : [{ type: "Report", id: "LIST" }],
    }),

    // Create a new report (multipart form-data)
    createReport: builder.mutation({
      query: (formData) => ({
        url: "/report",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Report"],
    }),

    // Update an existing report
    updateReport: builder.mutation({
      query: ({ id, data }) => ({
        url: `/report/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Report", id }],
    }),

    returnToBankReport: builder.mutation({
      query: ({ id, data }) => ({
        url: `/report/return_to_bank/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Report", id }],
    }),

    validateReport: builder.mutation({
      query: (id) => ({
        url: `/report/${id}/validate`,
        method: "PATCH",
      }),
      invalidatesTags: (_result, _error, id) => [{ type: "Report", id }],
    }),

    deleteReport: builder.mutation({
      query: (id) => ({
        url: `/report/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Report", id }],
    }),
  }),
});

export const {
  useGetReportListQuery,
  useGetReportDetailQuery,
  useGetSubmittedReportsQuery,
  useDeleteReportMutation,
  useCreateReportMutation,
  useUpdateReportMutation,
  useReturnToBankReportMutation,
  useValidateReportMutation,
} = reportApi;
